import React from 'react';
import { createIcon } from '@chakra-ui/icon';
export default createIcon({
    displayName: 'CloseIcon',
    path: (React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M18.74 17.281a1 1 0 01-1.415 1.414l-5.303-5.303-5.3 5.3a1 1 0 11-1.414-1.414l5.3-5.3-5.303-5.303A1 1 0 016.719 5.26l5.303 5.304 5.307-5.307a1 1 0 011.414 1.414l-5.307 5.307 5.304 5.303z", fill: "currentColor" }))),
});
//# sourceMappingURL=Close.js.map